import { useLocation } from '@tanstack/react-router';
import type { LinkProps } from '@tanstack/react-router';

import { Breadcrumbs } from '../../../cdl/Breadcrumbs/Breadcrumbs';
import { translate } from '../../../common/helpers/translate.helper';
import { useRole } from '../../../common/hooks/useRole';

import { getLubesDetailBreadcrumbLabel } from './getLubesDetailBreadcrumbLabel';

export const LubesOfferDetailBreadcrumb = () => {
    const location = useLocation();
    const role = useRole();
    const originLocation = location.state?.originLocation;
    const fallbackLabel = translate(role.isSuperAdmin() ? 'navigation.offers' : 'navigation.orders');

    return (
        <Breadcrumbs
            links={[
                {
                    label: getLubesDetailBreadcrumbLabel(originLocation?.pathname, role.isSuperAdmin(), fallbackLabel),
                    linkOptions: {
                        to: originLocation?.pathname || '/offers',
                        search: originLocation?.search ?? { page: 0, tab: 'enquired' },
                    } as LinkProps,
                },
            ]}
        />
    );
};
